import { AuthController } from "./types";
import axios from '../axiosInstance';

export const Auth: AuthController = {
  signIn: request => axios.post('/auth/signIn', request).then(res => res.data),
  register: request => axios.post('/auth/register', request).then(res => res.data)
}

